/* RESPONSIBLE TEAM: team-proactive-support */
import ConnectorConfiguration from './connector-configuration';

export default class StandardConnectorConfiguration extends ConnectorConfiguration {
  constructor(inputs) {
    inputs.component = 'series/node/connectors/standard-connector';
    super(inputs);
  }
}
